import { render } from "./relocation_dialog.vue?vue&type=template&id=47bd0e95"
import script from "./relocation_dialog.vue?vue&type=script&lang=js"
export * from "./relocation_dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__